// --- React
import React from "react";
// --- External UI Libraries
import { Col } from "antd";
// --- Styles
import "./styles.scss";

/**
 * InputLabel component that displays a label and its associated content.
 *
 * @param {Object} props - Component props.
 * @param {string} props.label - The label text to be displayed.
 * @param {React.ReactNode} props.children - The child components or elements inside the label container.
 * @param {Object} props.colProps - Props to customize the column layout.
 * @returns {JSX.Element} The rendered InputLabel component.
 */
export function InputLabel({ label, children, colProps }) {
  return (
    <Col {...colProps} className="InputLabel">
      <h5>{label}</h5>
      {children}
    </Col>
  );
}
